export default from './ScrollBackground'


// WEBPACK FOOTER //
// ./src/components/ScrollBackground/index.js